<template>
  <b-form @submit.prevent="saveForm">
    <b-form-row>
      <b-col cols="12" lg="6">
        <b-form-group id="input-group-1" label-class="gk-label-margin gk-modal-label" label-for="input-1">
          <template slot="label">
            {{ $gettext('Date') }}
          </template>
          <b-form-datepicker id="input-1" v-model="item.date" no-flip initial-date="2021-01-01" :date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }" />
        </b-form-group>
      </b-col>
      <b-col cols="12" lg="6">
        <b-form-group id="input-group-2" label-class="gk-label-margin gk-modal-label" :label="$gettext('Amount*')" label-for="input-2">
          <b-form-input v-model="item.amount" type="number" required @input="costNumberChange" />
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group id="input-group-3" label-class="gk-label-margin gk-modal-label" :label="$gettext('Description')" label-for="input-3">
          <b-form-textarea v-model="item.description" :placeholder="$gettext('Insert investment description')" rows="6" />
        </b-form-group>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
import BalanceSheetService from "@/store/services/balancesheet.service";

export default {
  name: "AddEditItem",
  components: {},
  data() {
    return {
      item: {
        date: new Date(),
        description: null,
        amount: 0,
        writeoffyears_count: 0,
        writeoffyear_set: []
      }
    }
  },
  created() {
    if (this.$route.params['investmentId']) { // edit
      BalanceSheetService.retrieve(this.$route.params['investmentId']).then(response => {
        this.item = response.data;
      });
    }
  },
  methods: {
    saveForm() {
      let data = BalanceSheetService.prepareDataForUpdate(this.item);
      data.company_profile = window.company_id;
      if (this.$route.params['investmentId']) { // edit
        BalanceSheetService.update(this.item.id, data).then((response) => {
          this.$emit("edited", response.data);
        }).catch((response) => {
          let msg = this.$gettext("Error updating the investment item.");
          if (response["amount"])
              msg = response["amount"];
          this.$store.commit("setAlert", {
              title: this.$gettext("Something went wrong"),
              text: msg,
              variant: "error",
              duration: 4
          });
          window.mixpanel.track("Balance Sheet: item edited");
        });
      } else { // add
        BalanceSheetService.create(data).then((response) => {
          this.$emit("created", response.data);
        }).catch((response) => {
          let msg = this.$gettext("Error updating the investment item.");
          if (response["amount"])
              msg = response["amount"];
          else if (response["description"])
              msg = this.$gettext("Please fill in a description of the investment.");
          this.$store.commit("setAlert", {
              title: this.$gettext("Something went wrong"),
              text: msg,
              variant: "error",
              duration: 4
          });
          window.mixpanel.track("Balance Sheet: item created");
        });
      }
    }
  }
}
</script>

<style scoped>

</style>